import { ItemCountDS } from '@src/components/blocks/item-count-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ItemCountLegacy } from './item-count-legacy'

export interface ItemCountProps {
  totalItems: number
  isMobile: boolean
}

export const ItemCount = ({ totalItems, isMobile }: ItemCountProps) => {
  if (shouldUseDesignSystem()) {
    return <ItemCountDS totalItems={totalItems} />
  }

  if (!isMobile) {
    return null
  }

  return <ItemCountLegacy totalItems={totalItems} />
}
